import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import _ from 'lodash';
import { couponDiscountTypeMap } from '@/views/config/coupon/helper/constant';

export default {
  key: planTypes[planTypes.MASTER_CLASS],
  data() {
    return {
      logo: getPlanLogo(planTypes.MASTER_CLASS),
      title: '',
      subtitle: '',
      planTitle: this.$t('billing.partner.masterclass.title'),
      description: this.$t('billing.partner.masterclass.desc'),
      planType: planTypes.MASTER_CLASS,
      licenseTooltip: this.$t('billing.partner.masterclass.license_tooltip'),
      configDescription: this.$t('billing.partner.masterclass.desc'),
    };
  },
  computed: {
    ...mapGetters(['planMapFlat', 'partnerRefer']),
    plan() {
      return plansof(this.planMapFlat).type(this.planType).get(0) || {};
    },
    singleOriginAmount() {
      return _.get(this.plan, ['amount'], 0);
    },
    singleDiscountAmount() {
      const couponMeta = this.partnerRefer?.coupon || {};
      const partnerCouponDiscountInfo = { ...couponMeta?.discountInfo, ...couponMeta?.discountInfoExtension };
      const { discount = 0, couponDiscountType } = _.get(partnerCouponDiscountInfo, [this.plan?.plan_code], {});
      const singleDiscount = couponDiscountType === couponDiscountTypeMap.fixedAmount ? discount : (this.singleOriginAmount * (discount / 100));

      return singleDiscount || 0;
    },
    afterSingleDiscountAmount() {
      return this.singleOriginAmount - this.singleDiscountAmount;
    },
    discountPercentage() {
      return _.parseInt(((this.singleDiscountAmount / this.singleOriginAmount) * 100).toString());
    },
    planCycleValue() {
      return _.get(this.plan, 'planPeriod', 12);
    },
  },
  methods: {
    rebrandMasterClassNames(name = "") {
      return _.replace(name, "Individual", "Standard");
    }
  },
  watch: {
    planCycleValue: {
      immediate: true,
      handler(val) {
        const title = this.$t('billing.partner.masterclass.display_title', [val]);
        this.title = this.rebrandMasterClassNames(title);
      },
    },
  },
};
